import { SampleNavHeightPx } from 'constants/navBar';
import { SamplesBrand } from 'constants/brands';
import { zIndex } from 'constants/zIndex';
import React from 'react';
import { ProductHeader, Nav, useBreakpoint, Divider } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import { RouterLink } from 'components/CommonUi';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';
import { CreditsOrUpsell } from './components/CreditsOrUpsell';
import { usePrivateNavigation, usePublicNavigation } from './hooks';

export const MainNavigation = () => {
    const { isDAWPlugin } = useExecutionEnvironmentContext();
    const isMobile = useBreakpoint('md');
    const path = '/';

    const getPublicNavigation = usePublicNavigation({ isDAWPlugin });
    const getPrivateNavigation = usePrivateNavigation();

    return (
        <ProductHeader
            padding={{ base: 'sm 0 xl', md: 'sm 0' }}
            width="100%"
            display="flex"
            justifyContent="space-between"
            style={{ height: SampleNavHeightPx }}
            id="product-header-wrapper"
            zIndex={zIndex.mainNavigation}
        >
            <ProductHeader.Name fontWeight="extrabold" as="span">
                <Nav.Link
                    as={RouterLink}
                    to={path}
                    fontWeight="700"
                    textStyle="lead"
                    color="text.high"
                    p="none"
                >
                    {SamplesBrand}
                </Nav.Link>
            </ProductHeader.Name>
            <ProductHeader.Collapse
                triggerLabel="Menu"
                className={css({
                    position: {
                        base: 'absolute',
                        md: 'relative',
                    },
                    right: '10px',
                })}
            >
                {
                    // @ts-expect-error ProductHeader.Collapse expect ReactNode
                    ({
                        onClose,
                    }: {
                        onClose: () => void;
                    }): React.ReactElement => {
                        const privateNavigation = getPrivateNavigation(onClose);

                        return (
                            <ProductHeader.Nav gap="2xs" alignItems="left">
                                {getPublicNavigation(onClose)}
                                {isMobile && (
                                    <>
                                        <Divider key="divider-1" />
                                        {privateNavigation && (
                                            <>
                                                {privateNavigation}
                                                <Divider key="divider-2" />
                                            </>
                                        )}
                                        <CreditsOrUpsell
                                            key={'credit-balance'}
                                            onClick={onClose}
                                        />
                                    </>
                                )}
                            </ProductHeader.Nav>
                        );
                    }
                }
            </ProductHeader.Collapse>
            <ProductHeader.Addon>
                {!isMobile && (
                    <Nav
                        key="authenticated"
                        minWidth="fit-content"
                        width="auto"
                        flex="0 1 auto"
                    >
                        {getPrivateNavigation()}
                        <CreditsOrUpsell key="credit-balance" />
                    </Nav>
                )}
            </ProductHeader.Addon>
        </ProductHeader>
    );
};
